import React from 'react'
import PropTypes from 'prop-types'

import {
  DashboardModule,
} from '@domain-group/suit-theme'

import LogoListItem from '@components/LogoListItem'

const Logo = (props) => {
  const { publicationPayload } = props

  const {
    callbacks: { uploadLogo },
    loading,
    publication: { logo },
  } = publicationPayload

  return (
    <DashboardModule loading={loading} title="Logo">
      {!loading && (
        <LogoListItem
          callbacks={{ uploadLogo: () => uploadLogo() }}
          logo={logo}
          title="Logo"
        />
      )}
    </DashboardModule>
  )
}

Logo.propTypes = {
  publicationPayload: PropTypes.object.isRequired,
}

export default Logo
